import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    videoContent: {},
    courses:[],
    videoContents:[],
    comments:[],
    courseIdParam: 0,
    typeParam:1,//1视频,2音频
    channelId:0,
  },
  mutations: {
    setVideoContent(state,videoContent) {
      state.videoContent = videoContent
    },
    setCourses(state,courses) {
      state.courses = courses
    },
    setVideoContents(state,videoContents) {
      state.videoContents = videoContents
    },
    setComments(state,comments) {
      state.comments = comments
    },
    setCourseIdParam(state,courseId) {
      state.courseIdParam = courseId
    },
    setTypeParam(state,type) {
      state.typeParam = type
    },
    setChannelId(state,channelId) {
      state.channelId = channelId
    },
  },
  actions: {
  },
  modules: {
  }
})
